import React from "react";

const Loader = ({
  isDark,
  isStack,
  hideOverlay,
  loaderStyle: customLoaderStyle,
  ...props
}) => {
  let loaderStyle = {};
  if (isDark) {
    loaderStyle.color = "#000";
  }

  loaderStyle = { ...loaderStyle, ...(customLoaderStyle || {}) };

  return (
    <div
      {...props}
      className={`loader-overlay ${isStack ? "is-stack" : ""} ${
        props?.className || ""
      } ${hideOverlay ? "!bg-transparent" : ""}`}
    >
      <div className="loader" style={{ ...loaderStyle }}></div>
    </div>
  );
};

export default Loader;
